import React from 'react';
import { useTranslation } from 'react-i18next';

import CustomerAddress from './RenderAddress/CustomerAddress';
import RelayAddress from './RenderAddress/RelayAddress';
import MondialRelayAddress from './RenderAddress/MondialRelayAddress';
import ShippingMethod from 'model/ShippingMethod';
import { DeliveryMethod } from 'types/Cart';

import styles from './CheckoutSummaryDelivery.module.scss';

export default function CheckoutSummaryDelivery({
  method,
}: {
  method: CheckoutSummaryDeliveryMethodType;
}): JSX.Element {
  const { t } = useTranslation(['checkout', 'translation']);
  const { delivery, address, relayPoint, mondialRelayPoint } = { ...method };
  const methods: ShippingMethodTypes = {
    [ShippingMethod.colieco]: {
      title: 'LABEL_MODE_COLIECO',
      address,
    },
    [ShippingMethod.colissimo]: {
      title: 'LABEL_MODE_COLISSIMO',
      address,
    },
    [ShippingMethod.standardPackage]: {
      title: 'LABEL_MODE_STANDARD',
      address,
    },
    [ShippingMethod.relay]: {
      title: 'LABEL_MODE_RELAY',
      component: RelayAddress,
      address: relayPoint,
    },
    [ShippingMethod.mondialRelay]: {
      title: 'SUMMARY_SHIPPING_METHOD_MONDIAL_RELAY',
      component: MondialRelayAddress,
      address: mondialRelayPoint,
    },
  };

  const methodAddress = methods[delivery].address;
  const AddressComponent = methods[delivery].component || CustomerAddress;

  return (
    <div className={styles.container}>
      <p className={styles.title}>
        {t('LABEL_TWO_POINTS', {
          ns: 'translation',
          label: t('LABEL_DELIVERY', { ns: 'translation' }),
        })}
      </p>
      <div>
        <p className={styles.mode}>{t(methods[delivery].title)}</p>
        <div className={styles.details}>
          {methodAddress && <AddressComponent address={methodAddress} />}
        </div>
      </div>
    </div>
  );
}

export type CheckoutSummaryDeliveryMethodType = DeliveryMethod & {
  delivery: string;
};

type AddressType =
  | DeliveryMethod['address']
  | DeliveryMethod['relayPoint']
  | DeliveryMethod['mondialRelayPoint'];

type ShippingMethodTypes = Record<
  string,
  {
    title: string;
    component?: React.ElementType;
    address: AddressType | null;
  }
>;
